import React from 'react';

const SuccessCircleIcon = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Passed Icon"
  >
    <circle cx={size / 2} cy={size / 2} r={size / 2} fill="#176F2C" />
    <path
      d="M6 10.5L9 13.5L15 7"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default SuccessCircleIcon;
